import logo from './logo.svg';
import './App.css';
import { useEffect } from "react";
import Home from './components/Home/Home.js';
import Splash from './components/Splash/Splash.js'
import { Routes, Route } from 'react-router-dom';
import Details from './components/Details/Details';

function App() {
  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, []);
  return (

    <div className="App">

      <Routes>

        <Route path="/" element={<Splash />}></Route>
        <Route path="/home" element={<Home />}></Route>

        <Route path='/salaamstree/:title/:id' element={<Details />}></Route>

      </Routes>

    </div>
  );
}

export default App;
